import React, { useState } from "react";
import { LoginImage, logo } from "../../../constants/images";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../authProvider";
import axios from "axios";

const SuperadminLogin = () => {
  const { setToken } = useAuth();
  const navigate = useNavigate();

  //set user data state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  //modal response
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showServerErrorModal, setServerErrorModal] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/admin/auth/login`,
        {
          email,
          password,
        }
      );

      if (response.status === 200) {
        setToken(`${response.data.data.accessToken}`);
        //   console.log(`${response.data.data.accessToken}`);
        // Login successful, r
        console.log("Login successful:", response.data);
        setShowSuccessModal(true);
        // Navigate to the new page after successful login
        navigate("/dashboard");
      }
    } catch (error) {
      if (error.response) {
        // Handle login failure
        console.error("Login Failed", error.response);
        setShowErrorModal(true);
      } else {
        if (error.request) {
          setServerErrorModal(true);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="w-full flex">
      <div className="flex-1 flex items-center justify-center h-screen">
        <div className="w-full max-w-md space-y-8 px-4 bg-white text-gray-600 sm:px-0">
          <div className="">
            <img src={logo.mmbLogo} width={348} className="" alt="mmb-logo" />
            <div className="mt-5 space-y-2">
              <p className="py-4 text-blueTheme font-400 leading-[22px] font-Poppins text-[16px]">
                welcome back !!
              </p>
              <h3 className="text-black text-2xl font-semibold leading-[84px] font-Poppins sm:text-[56px]">
                Sign in
              </h3>
            </div>
          </div>
          <form id="login" onSubmit={handleLogin} className="space-y-5">
            <div>
              <label
                htmlFor="email"
                className="font-light font-Poppins leading-6 text-base text-black"
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="admin@mymedicalbank.com"
                required
                onChange={handleEmailChange}
                className="w-[478px] h-[46px] bg-bglogininput mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-bglogininput shadow-sm rounded"
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="text-[16px] font-light font-Poppins leading-6 text-base text-black"
              >
                Password
              </label>
              <label
                htmlFor="password"
                className=" pl-[14rem] text-[14px] font-light font-Poppins leading-6 text-base text-black"
              >
                <a href="|">Forgot Password?</a>
              </label>
              <input
                type="password"
                name="password"
                id="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="*******"
                required
                className="w-[478px] h-[46px] bg-bglogininput mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-bglogininput shadow-sm rounded"
              />
            </div>
            <button
              type="submit"
              className="w-[150px] h-[46px] leading-6  text-white bg-bgloginbutton hover:bg-bg-bgloginbutton/90 
                                rounded-3xl text-[16px] leading-16 font-semibold font-Poppins px-6 py-2.5 text-center inline-flex items-center 
                                mr-2 mb-2"
              disabled={loading}
            >
              {" "}
              submit
              {loading ? (
                <svg
                  aria-hidden="true"
                  className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-red-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-8 h-6 pl-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                  />
                </svg>
              )}
            </button>
          </form>
          {/* Success Modal */}
          {showSuccessModal && (
            <div className="mt-12 mx-4 px-4 rounded-md border-l-4 border-green-500 bg-green-50 md:max-w-2xl md:mx-auto md:px-8">
              <div className="flex justify-between py-3">
                <div className="flex">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 rounded-full text-green-500"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="self-center ml-3">
                    <span className="text-green-600 font-semibold">
                      Success
                    </span>
                    <p className="text-green-600 mt-1">Login successfull</p>
                  </div>
                </div>
                <button
                  className="self-start text-green-500"
                  onClick={() => setShowSuccessModal(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}

          {/* Failed  Modal */}
          {showErrorModal && (
            <div className="mt-12 mx-4 px-4 rounded-md border-l-4 border-red-500 bg-red-50 md:max-w-2xl md:mx-auto md:px-8">
              <div className="flex justify-between py-3">
                <div className="flex">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-red-500"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="self-center ml-3">
                    <span className="text-red-600 font-semibold">Error</span>
                    <p className="text-red-600 mt-1">
                      Please Enter Correct Email and Password
                    </p>
                  </div>
                </div>
                <button
                  className="self-start text-red-500"
                  onClick={() => setShowErrorModal(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}

          {/* Failed with server   Modal */}
          {showServerErrorModal && (
            <div className="mt-12 mx-4 px-4 rounded-md border-l-4 border-red-500 bg-red-50 md:max-w-2xl md:mx-auto md:px-8">
              <div className="flex justify-between py-3">
                <div className="flex">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-red-500"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div className="self-center ml-3">
                    <span className="text-red-600 font-semibold">Error</span>
                    <p className="text-red-600 mt-1">Cant connect to sever</p>
                  </div>
                </div>
                <button
                  className="self-start text-red-500"
                  onClick={() => setServerErrorModal(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="relative flex-1 hidden items-center justify-center h-[725px] bg-white lg:flex">
        <div className="relative z-10 w-full max-w-md bg-[#FFEDE1] py-32">
          <img src={LoginImage.flyer} width={755} alt="mmb_login_image" />
        </div>
      </div>
    </main>
  );
};

export default SuperadminLogin;
